<script>
export default {
  props: {
    value: null,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        return this.$emit('change', value)
      },
    },
  },
  render() {
    return ''
  },
}
</script>
